// src/components/pages/Unauthorized.js
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Healthcheck = () => {
  const theme = useTheme();
  return (
    <Box sx={{ textAlign: "center", mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Health Check
      </Typography>
      <Typography variant="body1" gutterBottom>
        Glazer App is running smoothly!
      </Typography>
    </Box>
  );
};

export default Healthcheck;
